const QUERY_GRID_BREAKPOINTS = [
  { minWidth: 1200, span: 6 },
  { minWidth: 992, span: 6 },
  { minWidth: 768, span: 8 },
];

export default {
  data() {
    return {
      queryColSpan: 6,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.updateQueryColSpanByContainer();
      this.bindQueryGridContainerResize();
    });
  },

  beforeDestroy() {
    this.unbindQueryGridContainerResize();
  },

  methods: {
    getQueryGridContainer() {
      if (!this.$el) return null;
      return this.$el.parentElement || this.$el;
    },

    getQueryColSpanByContainerWidth(width) {
      const matched = QUERY_GRID_BREAKPOINTS.find(item => width >= item.minWidth);
      return matched ? matched.span : 24;
    },

    updateQueryColSpanByContainer() {
      const container = this.getQueryGridContainer();
      if (!container) return;

      const width = container.getBoundingClientRect().width || container.clientWidth || container.offsetWidth || 0;
      const nextSpan = this.getQueryColSpanByContainerWidth(width);

      if (nextSpan !== this.queryColSpan) {
        this.queryColSpan = nextSpan;
      }
    },

    bindQueryGridContainerResize() {
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.updateQueryColSpanByContainer);
      }

      if (typeof ResizeObserver !== 'undefined') {
        const container = this.getQueryGridContainer();

        if (container) {
          this.queryGridResizeObserver = new ResizeObserver(() => {
            this.updateQueryColSpanByContainer();
          });
          this.queryGridResizeObserver.observe(container);
        }
      }
    },

    unbindQueryGridContainerResize() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.updateQueryColSpanByContainer);
      }

      if (this.queryGridResizeObserver) {
        this.queryGridResizeObserver.disconnect();
        this.queryGridResizeObserver = null;
      }
    },
  },
};
